import * as React from "react";
import Svg, { Path } from "react-native-svg";

const SvgComponent = (props) => (
  <Svg
    {...props}
    width={22}
    height={22}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <Path
      d="M11 0C4.928 0 0 4.928 0 11s4.928 11 11 11 11-4.928 11-11S17.072 0 11 0Zm0 19.8A8.798 8.798 0 0 1 2.2 11c0-4.862 3.938-8.8 8.8-8.8s8.8 3.938 8.8 8.8-3.938 8.8-8.8 8.8Z"
      fill="#000"
      fillOpacity={0.7}
    />
  </Svg>
);

export default SvgComponent;
